module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/logo/logo-full-214.png"+" 214w",
        images: [{path: __webpack_public_path__ + "assets/images/logo/logo-full-214.png",width: 214,height: 75}],
        src: __webpack_public_path__ + "assets/images/logo/logo-full-214.png",
        toString: function(){return __webpack_public_path__ + "assets/images/logo/logo-full-214.png"},
        
        width: 214,
        height: 75
      }